/**
 * Preload designated images.
 */

'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'preload', () => ({

		siteImage: false,
		images   : document.querySelectorAll( '[data-image]' ),

		init() {
			this.images.forEach( image => {
				const imgObj = new Image();
				imgObj.src = image.dataset.image;
			});
		},
	}) );
});
